import {useRef} from 'react'
import {twJoin} from 'tailwind-merge'
import {useTranslation} from 'react-i18next'

import {useScrollIntoViewEffect} from '../../../hooks'
import {LazyImage, useSlideshowContext} from '../../'

interface SlideshowThumbnailProps {
  index: number
}

export const SlideshowThumbnail = ({index}: SlideshowThumbnailProps) => {
  const ref = useRef<HTMLButtonElement>(null)
  const {showIndex, currentIndex, items} = useSlideshowContext()
  const {t} = useTranslation()

  const item = items[index]
  const isActive = currentIndex === index

  useScrollIntoViewEffect({ref, shouldScroll: isActive})

  const onClick = (): void => {
    showIndex(index)
  }

  return (
    <button
      ref={ref}
      onClick={onClick}
      aria-label={t('common:slideshow.showItem', {index: index + 1})}
      className={twJoin(
        'group relative size-spacing-44 shrink-0 scroll-mx-[38px]',
        'flex justify-center items-center',
        isActive && 'outline outline-1 outline-interactive-surface-outline-inversed-hovered -outline-offset-1',
      )}
    >
      <span className={'absolute inset-0 group-hover:bg-media-bg/10 group-active:bg-media-bg/20'} />
      <LazyImage
        key={index}
        className={twJoin(
          'size-spacing-44 object-cover object-center',
        )}
        alt={item.alt}
        src={item.thumbnailSrc ?? item.placeholderSrc ?? item.src}
      />
    </button>
  )
}
